<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      top="5vh"
    >
      <el-form
        :model="bankAccountForm"
        id="bankAccountForm"
        ref="bankAccountForm"
        label-width="200px"
        size="small"
        :rules="bankAccountFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-alert
          v-if="bankAccountForm.status === 'closed'"
          title="Account make to closed can't be re-active again"
          type="error"
          show-icon
        >
        </el-alert>

        <el-form-item label="Type" prop="type" v-if="actionForm === 'add'">
          <el-select
            v-model="bankAccountForm.type"
            placeholder="Please select Type"
          >
            <el-option label="Currency" value="currency"></el-option>
            <el-option label="Asset" value="asset"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="Currency"
          prop="currency"
          v-if="actionForm === 'add'"
        >
          <el-select
            v-model="bankAccountForm.currency"
            placeholder="Please select currency"
          >
            <el-option
              v-for="item in currencies"
              :key="item.uid"
              :label="`${item.currency.toUpperCase()}`"
              :value="item.currency"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="Purpose"
          prop="purpose"
          v-if="apiMode === 'project'"
        >
          <el-select
            v-model="bankAccountForm.purpose"
            placeholder="Please select purpose"
          >
            <el-option label="Prefunded" value="Prefunded"></el-option>
            <el-option
              label="Commission/Fee"
              value="Commission-Fee"
            ></el-option>
            <el-option
              label="Recon Pending Account"
              value="Recon-Pending-AC"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Status" prop="status" v-if="actionForm === 'edit'">
          <el-select
            v-model="bankAccountForm.status"
            placeholder="Please select status"
          >
            <el-option label="Active" value="active"></el-option>
            <el-option
              label="Close by Compliance"
              value="closedbycompliance"
            ></el-option>
            <el-option
              label="Closed"
              value="closed"
              :disabled="ledger.balance > 0"
            ></el-option>
            <el-option label="Suspended" value="suspended"></el-option>
          </el-select>
        </el-form-item>

        <div v-if="bankAccountForm.currency == 'gbp'">
          <el-form-item label="Account Number">
            <el-input v-model="bankAccountForm.gbp_accountnumber"></el-input>
          </el-form-item>

          <el-form-item label="Sort Code">
            <el-input v-model="bankAccountForm.gbp_sortcode"></el-input>
          </el-form-item>

          <el-form-item label="Inter IBAN">
            <el-input v-model="bankAccountForm.gbp_iban"></el-input>
          </el-form-item>

          <el-form-item label="Inter BIC">
            <el-input v-model="bankAccountForm.gbp_bic"></el-input>
          </el-form-item>

          <el-form-item label="Correspond">
            <el-input v-model="bankAccountForm.gbp_correspond"></el-input>
          </el-form-item>
        </div>

        <div v-if="bankAccountForm.currency == 'eur'">
          <el-form-item label="IBAN">
            <el-input v-model="bankAccountForm.eur_iban"></el-input>
          </el-form-item>

          <el-form-item label="BIC">
            <el-input v-model="bankAccountForm.eur_bic"></el-input>
          </el-form-item>

          <el-form-item label="Reference">
            <el-input v-model="bankAccountForm.eur_ref"></el-input>
          </el-form-item>

          <el-form-item label="Inter IBAN">
            <el-input v-model="bankAccountForm.eur_iban_inter"></el-input>
          </el-form-item>

          <el-form-item label="Inter BIC">
            <el-input v-model="bankAccountForm.eur_bic_inter"></el-input>
          </el-form-item>

          <el-form-item label="Correspond">
            <el-input v-model="bankAccountForm.eur_correspond"></el-input>
          </el-form-item>
        </div>

        <div v-if="!['gbp', 'eur'].includes(bankAccountForm.currency)">
          <el-form-item label="Inter IBAN">
            <el-input v-model="bankAccountForm.usd_iban_inter"></el-input>
          </el-form-item>

          <el-form-item label="Inter BIC">
            <el-input v-model="bankAccountForm.usd_bic_inter"></el-input>
          </el-form-item>

          <el-form-item label="Correspond">
            <el-input v-model="bankAccountForm.usd_correspond"></el-input>
          </el-form-item>
        </div>

        <div v-if="apiMode === 'project'">
          <el-form-item label="Override Ledger ID">
            <el-input v-model="bankAccountForm.overrideLedgerid"></el-input>
          </el-form-item>

          <el-form-item label="Is white label commission">
            <el-checkbox v-model="bankAccountForm.isWbcommission"></el-checkbox>
          </el-form-item>
          <el-form-item label="Is override">
            <el-checkbox v-model="bankAccountForm.isOverride"></el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submiting"
          type="primary"
          @click="submitBankAccount()"
          >Submit</el-button
        >
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrencyActive } from "@/api/currency";
import {
  getBankAccountBy,
  createBankAccount,
  updateBankAccount,
} from "@/api/bank-account";
export default {
  props: {
    customerUID: String,
    projectUID: String,
    apiMode: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogTitle: "",
      submiting: false,
      actionForm: "",
      currencies: [],
      errMsg: "",
      ledger: {},
      bankAccountForm: {
        bankholderID: "",
        customer_uid: this.customerUID,
        project_uid: this.projectUID,
        type: "currency",
        currency: "gbp",
        status: "active",
        purpose: "Prefunded",
        overrideLedgerid: "",
        isWbcommission: false,
        isOverride: false,
      },
      bankAccountFormRules: {
        type: [
          {
            required: true,
            message: "Please select type",
            trigger: "blur",
          },
        ],
        currency: [
          {
            required: true,
            message: "Please select currency",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "Please select status",
            trigger: "blur",
          },
        ],
        purpose: [
          {
            required: true,
            message: "Please select purpose",
            trigger: "blur",
          },
        ],
      },
      topupFormRules: {
        amount: [
          {
            required: true,
            message: "Please enter amount",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    getCurrency() {
      getCurrencyActive(this.projectUID).then(({ result, data }) => {
        if (result) {
          this.currencies = data;
        }
      });
    },
    getBankAccountDataToEdit(bankholderID) {
      const loading = this.$notifyloading("Loading data...");
      getBankAccountBy(bankholderID).then(({ result, data }) => {
        if (result && data) {
          this.bankAccountForm.bankholderID = data.bankholderId;
          this.bankAccountForm.type = data.type;
          this.bankAccountForm.currency = data.currency;
          this.bankAccountForm.status = data.status;
          this.bankAccountForm.purpose = data.purpose;
          this.bankAccountForm.overrideLedgerid = data.overrideLedgerid;
          this.bankAccountForm.isWbcommission = data.isWbcommission == 1;
          this.bankAccountForm.isOverride = data.isOverride == 1;
          this.ledger.balance = data.balance;
          this.dialogTitle = `Update Bank Account Balance: ${
            data.balanceFormat
          } ${data.currency.toUpperCase()}`;
          this.dialogFormVisible = true;
          loading.close();
        }
      });
    },
    mapData() {
      const formData = {
        customer_uid: this.bankAccountForm.customer_uid,
        project_uid: this.bankAccountForm.project_uid,
        type: this.bankAccountForm.type,
        currency: this.bankAccountForm.currency,
        purpose: this.bankAccountForm.purpose,
        status: this.bankAccountForm.status,
      };

      if (this.apiMode == "project") {
        formData.overrideLedgerid = this.bankAccountForm.overrideLedgerid;
        formData.isWbcommission = this.bankAccountForm.isWbcommission;
        formData.isOverride = this.bankAccountForm.isOverride;
      }

      if(this.bankAccountForm.currency == 'gbp'){
        formData.gbp_accountnumber = this.bankAccountForm.gbp_accountnumber || ""
        formData.gbp_sortcode = this.bankAccountForm.gbp_sortcode || ""
        formData.gbp_iban = this.bankAccountForm.gbp_iban || ""
        formData.gbp_bic = this.bankAccountForm.gbp_bic || ""
        formData.gbp_correspond = this.bankAccountForm.gbp_correspond || ""
      }else if(this.bankAccountForm.currency == 'eur'){
        formData.eur_iban = this.bankAccountForm.eur_iban || ""
        formData.eur_bic = this.bankAccountForm.eur_bic || ""
        formData.eur_ref = this.bankAccountForm.eur_ref || ""
        formData.eur_iban_inter = this.bankAccountForm.eur_iban_inter || ""
        formData.eur_bic_inter = this.bankAccountForm.eur_bic_inter || ""
        formData.eur_correspond = this.bankAccountForm.eur_correspond || ""
      }else{
        formData.usd_iban_inter = this.bankAccountForm.usd_iban_inter || ""
        formData.usd_bic_inter = this.bankAccountForm.usd_bic_inter || ""
        formData.usd_correspond = this.bankAccountForm.usd_correspond || ""
      }


      return formData;
    },
    showDialog(action, bankholderID) {
      this.actionForm = action;
      this.bankAccountForm.bankholderID = "";
      this.resetForm();
      this.getCurrency();
      if (this.actionForm === "add") {
        this.dialogTitle = "Create Bank Account";
        this.dialogFormVisible = true;
      } else {
        this.getBankAccountDataToEdit(bankholderID);
      }
    },
    createBankAccount() {
      const formData = this.mapData();
      this.submiting = true;
      this.errMsg = "";
      createBankAccount(formData).then(({ result, message }) => {
        this.submiting = false;
        if (result) {
          this.$notify({
            title: "Success",
            message: `Create Bank Account successfully`,
            type: "success",
            duration: 2000,
          });
          this.dialogFormVisible = false;
          this.$emit("submited");
        } else {
          this.errMsg = message;
        }
      });
    },
    updateBankAccount() {
      const formData = this.mapData();
      this.submiting = true;
      this.errMsg = "";
      updateBankAccount(this.bankAccountForm.bankholderID, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Bank Account successfully`,
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            this.$emit("submited");
          } else {
            this.errMsg = message;
          }
        }
      );
    },
    submitBankAccount() {
      this.$refs.bankAccountForm.validate((valid) => {
        if (valid) {
          if (this.actionForm === "add") {
            this.createBankAccount();
          } else {
            this.updateBankAccount();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      if (this.$refs.bankAccountForm) this.$refs.bankAccountForm.resetFields();
    },
  },
};
</script>

<style></style>
